module.exports = __webpack_public_path__ + "assets/images/H-orange-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/H-orange-icon.png
// module id = 390
// module chunks = 1